import angular from "angular";

angular
    .module('app')
    .component('resetPasswordForm', {
        template: require('./reset-password-form.html'),
        controller: ['$http', '$document', '$timeout', '$interval', 'Notifier', 'trans', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, $document, $timeout, $interval, Notifier, trans) {

    let $ctrl = this;

    $ctrl.step = 1;

    $ctrl.phoneMasks = [
        {country: 'Kazakhstan', country_code: 'KZ', phone_code: '+7', phone_mask: '+7 (999) 999-99-99'},
        {country: 'Kyrgyzstan', country_code: 'KG', phone_code: '+996', phone_mask: '+\\9\\96 (999) 999-999'},
        {country: 'Turkish', country_code: 'TR', phone_code: '+90', phone_mask: '+7 (999) 999-99-99'},
        {country: 'Russian', country_code: 'RU', phone_code: '+7', phone_mask: '+7 (999) 999-99-99'},
        {country: 'Usa', country_code: 'USA', phone_code: '+1', phone_mask: '+1 (999) 999-99-99'},
        {country: 'UAE', country_code: 'UAE', phone_code: '+971', phone_mask: '+\\971 (999) 99-9999'},
        {country: 'SPAIN', country_code: 'SPA', phone_code: '+34', phone_mask: '+34 (999) 999-999'}
    ];

    $ctrl.selectedMask = $ctrl.phoneMasks[0];

    $ctrl.sessionId = null;
    $ctrl.phone = null;
    $ctrl.password = null;
    $ctrl.confirmPassword = null;

    $ctrl.$onInit = function () {
        focusOnPhone();
    };

    function focusOnPhone() {
        $timeout(function () {
            $document[0].getElementById('phone-input').focus();
        }, 300);
    }

    $ctrl.maskChanged = function () {
        $ctrl.phone = null;
        focusOnPhone();
    };

    $ctrl.sendCode = function () {

        if ($ctrl.sendCodeLoading) {
            return;
        }

        $ctrl.sendCodeLoading = true;
        $ctrl.sendCodeErrorMessage = null;
        $ctrl.validationErrors = null;

        let phone = $ctrl.phone.replace(/\D/g, '');

        $http
            .post('/reset-password/send-code', {phone})
            .then(
                function (response) {
                    $ctrl.sessionId = response.data.id;
                    $ctrl.step = 2;
                    $ctrl.code = [null, null, null, null];
                    $ctrl.sendCodeLoading = false;
                    $ctrl.codeCheckStatus = null;

                    resetSendCountdown(60);

                    $timeout(function () {
                        focusOnCodeInput(0);
                    }, 300);
                },
                function (error) {
                    $ctrl.sendCodeLoading = false;
                    if (error.status == 422) {
                        $ctrl.validationErrors = error.data.errors;
                    } else {
                        $ctrl.sendCodeErrorMessage = error.data.message || 'Undefined error';
                    }
                }
            );
    };

    function resetSendCountdown(sec) {
        if ($ctrl.countdownInterval) {
            $interval.cancel($ctrl.countdownInterval);
            $ctrl.countdownInterval = null;
        }

        $ctrl.countdown = sec;

        $ctrl.countdownInterval = $interval(function () {
            if ($ctrl.countdown) {
                $ctrl.countdown--;
            } else {
                $interval.cancel($ctrl.countdownInterval);
            }
        }, 1000);
    }

    function focusOnCodeInput(ind) {
        $document[0].getElementById('code-input-' + ind).focus();
    }

    function blurFromCodeInput(ind) {
        $document[0].getElementById('code-input-' + ind).blur();
    }

    $ctrl.codeInputItemFilled = function (ind) {

        if (!$ctrl.code[ind]) {
            return;
        }

        if (ind + 1 < $ctrl.code.length) {
            focusOnCodeInput(ind + 1);
        } else {
            blurFromCodeInput(ind);
            tryToSend();
        }

        function tryToSend() {
            let isComplete = true;
            for (let i = 0; i < $ctrl.code.length; i++) {
                if (!$ctrl.code[i]) {
                    isComplete = false;
                }
            }
            if (isComplete) {
                checkCode();
            }
        }
    };

    $ctrl.codeInputKeyDown = function (event, ind) {
        if (event.key == "Backspace" && !$ctrl.code[ind] && ind) {
            $timeout(function () {
                focusOnCodeInput(ind - 1);
            });
        }
    };

    function checkCode() {
        $ctrl.codeCheckLoading = true;
        $http
            .post('/reset-password/check-code', {
                session_id: $ctrl.sessionId,
                code: $ctrl.code.join('')
            })
            .then(
                function (response) {
                    $ctrl.codeCheckStatus = response.data.status;
                    $ctrl.codeCheckLoading = false;

                    if ($ctrl.codeCheckStatus == 'success') {
                        $timeout(function () {
                            $ctrl.step = 3;
                        }, 1000);
                    } else {
                        $timeout(function () {
                            $ctrl.codeCheckStatus = null;
                            for (let i = 0; i < $ctrl.code.length; i++) {
                                $ctrl.code[i] = null;
                            }
                        }, 2000);
                        $timeout(function () {
                            focusOnCodeInput(0);
                        }, 2200);
                    }
                },
                function (error) {
                    $ctrl.codeCheckLoading = false;
                    $ctrl.codeCheckErrorMessage = error.data.message;
                }
            );
    }

    $ctrl.retrySendCode = function () {

        if ($ctrl.retrySendLoading) {
            return;
        }

        $ctrl.retrySendLoading = true;

        $http
            .post('/reset-password/retry-send-code', {session_id: $ctrl.sessionId})
            .then(
                function () {
                    $ctrl.retrySendLoading = false;
                    resetSendCountdown(60);
                },
                function (error) {
                    $ctrl.retrySendLoading = false;
                    $ctrl.retrySendErrorMessage = error.data.message;
                }
            );
    };

    $ctrl.stepBack = function () {
        $ctrl.step = 1;
    };

    $ctrl.reset = function () {

        if ($ctrl.password != $ctrl.confirmPassword) {
            $ctrl.registerErrorMessage = trans('Password is not same confirm');
            return;
        }

        $ctrl.registerLoading = true;

        $http
            .post('/reset-password', {
                session_id: $ctrl.sessionId,
                password: $ctrl.password,
                password_confirmation: $ctrl.confirmPassword,
            })
            .then(
                function (response) {
                    $ctrl.registerLoading = false;
                    Notifier.success(trans('Reset password is complete'), 3);
                    $ctrl.close({$value: response.data});
                },
                function (error) {
                    $ctrl.registerLoading = false;
                    if (error.status == 422) {
                        $ctrl.validationErrors = error.data.errors;
                    } else {
                        $ctrl.registerErrorMessage = error.data.message;
                    }
                }
            );
    };

    $ctrl.dismissModal = function (command) {
        $ctrl.dismiss({$value: command});
    };

}
